import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Redirect, Route } from 'react-router-dom';
// import { Home, SignIn, SignUp, VideoCall } from './pages';
import * as ROUTES from './constants/routes';
import {
	Home,
	SignIn,
	SignUp,
	VideoCall,
	PasswordReset,
	Clients,
	Agenda,
	ThreeDHomes,
	Siteplan,
	Doc,
	DocClient,
	Profile,
	Finance,
	BoxMatrix,
	BookAppointment,
	Dashboard,
	SendEmail,
	RegisterLead,
	JoinAppointment,
	FileExplorer,
	Leads,
	Deals,
	Agreement,
	UserManagement,
	Reporting,
} from './pages';
import { useAuthListener } from './hooks/index';
import { AuthProvider } from './Auth';
import { useIdleTimer } from 'react-idle-timer';
import { signInSuccess } from './redux/signIn/actions';
import PrivateRoute from './helpers/PrivateRoute';
import {
	getAllAccessibilities,
	getRolesAccessibilities,
} from './redux/userManagement/actions';

// Redux
import { connect } from 'react-redux';
import { signout } from './api/Auth/logout.api';
import CustomAlerts from './components/alerts/CustomAlerts';
import { checkRolesAccessibilities } from './utils/checkRolesAccessibilities';
import CustomizedZendesk from './components/CustomizedZendesk/CustomizedZendesk';
import { useLocation } from 'react-router';

const App = ({
	userType,
	alert,
	signInSuccess,
	getAllAccessibilities,
	getRolesAccessibilities,
	rolesAccessibilities,
	currentLocation,
}) => {
	// DO NOT REMOVE THIS PLEASE ⚠️⚠️
	//toggle on off the console log
	window.console.log =
		window.console.debug =
		window.console.info =
		window.console.warn =
		window.console.error =
			function () {
				return false;
			};
	const [isIdle, setIsIdle] = useState(false);

	const timeout = 1200000;

	const handleOnActive = () => setIsIdle(false);
	const handleOnIdle = () => {
		signInSuccess({
			userInfo: {
				displayName: '',
				email: '',
				phoneNumber: '',
				photoURL: '',
				uid: '',
			},
			userType: '',
		});
		signout();
	};

	useIdleTimer({
		timeout,
		onActive: handleOnActive,
		onIdle: handleOnIdle,
	});

	useEffect(() => {
		getAllAccessibilities();
		getRolesAccessibilities();
	}, []);

	return (
		<AuthProvider>
			<CustomAlerts
				alertType={alert.alertType}
				alertMsg={alert.alertMessage}
				snackbar={alert.status}
			/>
			<Router>
				{currentLocation === 'profile' && <CustomizedZendesk />}
				<PrivateRoute
					exact
					path={ROUTES.HOME}
					component={ThreeDHomes}
				/>
				<Route exact path={ROUTES.SIGN_IN} component={SignIn} />
				{/* <Route exact path={ROUTES.SIGN_UP} component={SignUp} /> */}
				<Route
					exact
					path={ROUTES.RESET_PASSWORD}
					component={PasswordReset}
				/>
				{/* <PrivateRoute
					exact
					path={ROUTES.VIDEO_CALL}
					component={VideoCall}
				/>
				<PrivateRoute
					exact
					path={ROUTES.REPORTING}
					component={Reporting}
				/>
				<PrivateRoute
					exact
					path={ROUTES.MARKETING}
					component={SendEmail}
				/>
				<PrivateRoute
					exact
					path={ROUTES.REGISTER_LEAD}
					component={RegisterLead}
				/>
				<PrivateRoute
					exact
					path={ROUTES.THREE_D_HOMES}
					component={ThreeDHomes}
				/>
				<PrivateRoute
					exact
					path={ROUTES.DOC_CLIENT}
					component={DocClient}
				/>
				<PrivateRoute
					exact
					path={ROUTES.BOX_MATRIX}
					component={BoxMatrix}
				/>
				<PrivateRoute
					exact
					path={ROUTES.SITEPLAN}
					component={Siteplan}
				/>

				<PrivateRoute
					exact
					path={ROUTES.AGREEMENT}
					component={Agreement}
				/>
				<PrivateRoute
					exact
					path={ROUTES.USER_MANAMGEMENT}
					component={UserManagement}
				/>

				<PrivateRoute
					exact
					path={ROUTES.BOOK_APPOINTMENT}
					component={BookAppointment}
				/>
				<PrivateRoute
					exact
					path={ROUTES.JOIN_APPOINTMENT}
					component={JoinAppointment}
				/>
				<PrivateRoute
					exact
					path={ROUTES.FILE_EXPLORER}
					component={FileExplorer}
				/> */}

				{checkRolesAccessibilities(
					rolesAccessibilities,
					userType,
					'sidebar',
					'sidebar',
					2
				) && (
					<PrivateRoute
						exact
						path={ROUTES.AGENDA}
						component={Agenda}
					/>
				)}
				{checkRolesAccessibilities(
					rolesAccessibilities,
					userType,
					'sidebar',
					'sidebar',
					3
				) && (
					<PrivateRoute exact path={ROUTES.DEALS} component={Deals} />
				)}
				{checkRolesAccessibilities(
					rolesAccessibilities,
					userType,
					'sidebar',
					'sidebar',
					11
				) && (
					<PrivateRoute
						exact
						path={ROUTES.PROFILE}
						component={Profile}
					/>
				)}

				{(userType === 'admin' ||
					userType === 'superadmin' ||
					userType === 'salesadmin' ||
					userType === 'cobroker') && (
					<>
						<PrivateRoute
							exact
							path={ROUTES.MY_CLIENTS}
							component={Clients}
						/>

						<PrivateRoute
							exact
							path={ROUTES.LEADS}
							component={Leads}
						/>
						<PrivateRoute exact path={ROUTES.DOC} component={Doc} />

						{/* <Route exact path={ROUTES.DOCUMENT} component={Document} /> */}
						<PrivateRoute
							exact
							path={ROUTES.FILE_EXPLORER}
							component={FileExplorer}
						/>
						<PrivateRoute
							exact
							path={ROUTES.FINANCE}
							component={Finance}
						/>
					</>
				)}
				{!userType && (
					<Route
						path='/'
						render={() => {
							return <Redirect to={ROUTES.SIGN_IN} />;
						}}
					/>
				)}
			</Router>
		</AuthProvider>
	);
};

const mapStateToProps = (state) => ({
	userType: state.signIn.userType,
	alert: state.alert,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
	currentLocation: state.location.location,
});

export default connect(mapStateToProps, {
	signInSuccess,
	getAllAccessibilities,
	getRolesAccessibilities,
})(App);
